import { userConstants } from '../constants';
import { read_cookie, userCookie } from '../helpers/cookieHelper';

// let user = JSON.parse(localStorage.getItem('user'));
let user = read_cookie(userCookie);
const initialState = user ? { loggedIn: true, user } : {};

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.user
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        user: action.user
      };
    case userConstants.LOGIN_FAILURE:
      return {};
    case userConstants.LOGOUT:
      return {};
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/authentication.reducer.js